<template>
  <div>
    <a-table
      size="middle"
      :columns="columns"
      :data-source="items"
      :loading="loading"
      :scroll="{ x: 'max-content' }"
      :pagination="false"
      row-key="id"
    >
      <div slot="status" slot-scope="status, record">
        <div v-if="['part_allocated', 'all_allocated'].includes(record.status_slug)">
          <a @click="showAllocationRecordModal(record.id)">{{ status }}</a>
        </div>
        <div v-else>
          {{ status }}
        </div>
      </div>

      <div slot="item_no" slot-scope="item_no, record">
        <div v-if="isShowMenu('agent_purchase_items/show')">
          <a @click="showInfoModal(record.id)">
            {{ item_no }}
          </a>
          <a>
            <a-tooltip>
              <template slot="title">
                预制订单
              </template>
              <a-icon
                class="simiot-cursor-pointer"
                type="block"
                @click="ShowPreOrderItemInfoModal(record.agent_pre_order_item_id)"
              />
            </a-tooltip>
          </a>
        </div>
        <div v-else>
          {{ item_no }}
        </div>
      </div>
    </a-table>

    <!-- 详情模态框 -->
    <show-agent-purchase-item
      v-if="isShowInfoModal"
      :visible.sync="isShowInfoModal"
      :id="showingId"
      @showModal="showOperateModal"
    />

    <!-- 预制订单详情模态框 -->
    <show-agent-pre-order-item
      v-if="isShowPreOrderItemInfoModal"
      :visible.sync="isShowPreOrderItemInfoModal"
      :id="showingPreOrderItemId"
    />

    <!-- 配置模态框 -->
    <configure-agent-purchase-item
      v-if="isShowConfigureModal"
      :visible.sync="isShowConfigureModal"
      :id="showingId"
      @completed="fetchData"
    />

    <configure-module-purchase-item
      v-if="isShowConfigureModuleModal"
      :visible.sync="isShowConfigureModuleModal"
      :id="showingId"
      @completed="fetchData"
    />

    <configure-cpe-purchase-item
      v-if="isShowConfigureCpeModal"
      :visible.sync="isShowConfigureCpeModal"
      :id="showingId"
      @completed="fetchData"
    />

    <configure-esim-purchase-item
      v-if="isShowConfigureEsimModal"
      :visible.sync="isShowConfigureEsimModal"
      :id="showingId"
      @completed="fetchData"
    />

    <configure-profile-purchase-item
      v-if="isShowConfigureProfileModal"
      :visible.sync="isShowConfigureProfileModal"
      :id="showingId"
      @completed="fetchData"
    />

    <allocate-cards-to-top-agent
      v-if="isShowAllocationModal"
      :visible.sync="isShowAllocationModal"
      :agent-purchase-item-id="showingId"
      @completed="fetchData"
    />

    <allocate-modules-to-top-agent
      v-if="isShowAllocateModulesModal"
      :visible.sync="isShowAllocateModulesModal"
      :agent-purchase-item-id="showingId"
      @completed="fetchData"
    />

    <allocate-cpes-to-top-agent
      v-if="isShowAllocateCpesModal"
      :visible.sync="isShowAllocateCpesModal"
      :agent-purchase-item-id="showingId"
      @completed="fetchData"
    />

    <allocate-esims-to-top-agent
      v-if="isShowAllocateEsimsModal"
      :visible.sync="isShowAllocateEsimsModal"
      :agent-purchase-item-id="showingId"
      @completed="fetchData"
    />

    <allocate-profiles-to-top-agent
      v-if="isShowAllocateProfilesModal"
      :visible.sync="isShowAllocateProfilesModal"
      :agent-purchase-item-id="showingId"
      @completed="fetchData"
    />

    <invalid-agent-purchase-item
      v-if="isShowInvalidModal"
      :visible.sync="isShowInvalidModal"
      :id="showingId"
      @completed="fetchData"
    />

    <back-to-inventory-agent-purchase-item
      v-if="isShowBackToInventoryModal"
      :visible.sync="isShowBackToInventoryModal"
      :id="showingId"
      @completed="fetchData"
    />

    <agent-purchase-item-allocation-records
      v-if="isShowAllocationRecordsModal"
      :visible.sync="isShowAllocationRecordsModal"
      :id="showingId"
      @completed="fetchData"
    />
  </div>
</template>

<script>
import { hasPermission } from '@/utils/permission'
import { formatCurrency } from '@/utils/filter'

export default {
  name: 'AgentPurchaseItemsList',
  components: {
    ShowAgentPurchaseItem: () => import('@/views/agent_purchase_items/show/index'),
    ShowAgentPreOrderItem: () => import('@/views/agent_pre_order_items/show/index'),
    ConfigureAgentPurchaseItem: () => import('@/views/agent_purchase_items/Configure'),
    ConfigureModulePurchaseItem: () => import('@/views/agent_purchase_items/ConfigureModule'),
    ConfigureCpePurchaseItem: () => import('@/views/agent_purchase_items/ConfigureCpe'),
    ConfigureEsimPurchaseItem: () => import('@/views/agent_purchase_items/ConfigureEsim'),
    ConfigureProfilePurchaseItem: () => import('@/views/agent_purchase_items/ConfigureProfile'),
    AllocateCardsToTopAgent: () => import('@/views/agent_purchase_items/Allocate'),
    AllocateModulesToTopAgent: () => import('@/views/agent_purchase_items/AllocateModules'),
    AllocateCpesToTopAgent: () => import('@/views/agent_purchase_items/AllocateCpes'),
    AllocateEsimsToTopAgent: () => import('@/views/agent_purchase_items/AllocateEsims'),
    AllocateProfilesToTopAgent: () => import('@/views/agent_purchase_items/AllocateProfiles'),
    InvalidAgentPurchaseItem: () => import('@/views/agent_purchase_items/Invalid'),
    AgentPurchaseItemAllocationRecords: () => import('@/views/agent_purchase_items/AllocationRecord'),
    BackToInventoryAgentPurchaseItem: () => import('@/views/agent_purchase_items/BackToInventory')
  },
  props: {
    items: {
      type: Array,
      required: true,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      required: true,
      default() {
        return true
      }
    }
  },
  data() {
    return {
      isShowInfoModal: false,
      isShowPreOrderItemInfoModal: false,
      isShowConfigureModal: false,
      isShowConfigureModuleModal: false,
      isShowConfigureCpeModal: false,
      isShowConfigureEsimModal: false,
      isShowConfigureProfileModal: false,
      isShowAllocationModal: false,
      isShowAllocateModulesModal: false,
      isShowAllocateCpesModal: false,
      isShowAllocateEsimsModal: false,
      isShowAllocateProfilesModal: false,
      isShowInvalidModal: false,
      isShowAllocationRecordsModal: false,
      isShowBackToInventoryModal: false,
      showingId: 0,
      showingPreOrderItemId: 0
    }
  },
  computed: {
    columns() {
      return [
        {
          title: '项目状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          fixed: 'left'
        },
        {
          title: '项目编号',
          dataIndex: 'item_no',
          scopedSlots: { customRender: 'item_no' },
          fixed: 'left'
        },
        {
          title: '产品类型',
          dataIndex: 'product_type'
        },
        {
          title: '产品名称',
          dataIndex: 'product_name',
          ellipsis: true
        },
        {
          title: '运营商种类',
          dataIndex: 'carrier_type'
        },
        {
          title: '流量场景',
          dataIndex: 'traffic_scene'
        },
        {
          title: '用户业务模式',
          dataIndex: 'user_business_type'
        },
        {
          title: '套餐周期',
          dataIndex: 'service_cycle'
        },
        {
          title: '套餐容量',
          dataIndex: 'package_capacity'
        },
        {
          title: '卡品',
          dataIndex: 'card_type'
        },
        {
          title: '周期数',
          dataIndex: 'service_period'
        },
        {
          title: '采购数量',
          dataIndex: 'product_count'
        },
        {
          title: '单价(元)',
          dataIndex: 'distributor_price',
          customRender: formatCurrency
        },
        {
          title: '卡板价格',
          dataIndex: 'card_type_price'
        },
        {
          title: '产品费用(元)',
          dataIndex: 'product_fee',
          customRender: formatCurrency
        },
        {
          title: '卡板费用(元)',
          dataIndex: 'card_fee',
          customRender: formatCurrency
        },
        {
          title: '小计(元)',
          dataIndex: 'total_fee',
          customRender: formatCurrency
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: 150,
          ellipsis: true
        }
      ]
    }
  },
  methods: {
    isShowMenu(menu) {
      return hasPermission(menu)
    },

    showInfoModal(recordId) {
      this.showingId = recordId
      this.isShowInfoModal = true
    },

    ShowPreOrderItemInfoModal(preOrderItemId) {
      this.showingPreOrderItemId = preOrderItemId
      this.isShowPreOrderItemInfoModal = true
    },

    showAllocationRecordModal(recordId) {
      this.showingId = recordId
      this.isShowAllocationRecordsModal = true
    },

    showOperateModal(type, productTypeSlug) {
      if (type === 'configure') {
        this.isShowConfigureModal = true
      } else if (type === 'configure_module') {
        this.isShowConfigureModuleModal = true
      } else if (type === 'configure_cpe') {
        this.isShowConfigureCpeModal = true
      } else if (type === 'configure_esim') {
        this.isShowConfigureEsimModal = true
      } else if (type === 'configure_profile') {
        this.isShowConfigureProfileModal = true
      } else if (type === 'allocation') {
        if (productTypeSlug === 'comm_module') {
          this.isShowAllocateModulesModal = true
        } else if (productTypeSlug === 'cpe') {
          this.isShowAllocateCpesModal = true
        } else if (productTypeSlug === 'esim') {
          this.isShowAllocateEsimsModal = true
        } else if (productTypeSlug === 'profile') {
          this.isShowAllocateProfilesModal = true
        } else {
          this.isShowAllocationModal = true
        }
      } else if (type === 'invalid') {
        this.isShowInvalidModal = true
      } else if (type === 'back_to_inventory') {
        this.isShowBackToInventoryModal = true
      }
    },

    fetchData() {
      this.$emit('completed')
    }
  }
}
</script>

<style scoped>

</style>
